import React, { memo } from "react";

import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";

import { VEHICLE_WIZARD_SAMPLE } from "../consts";
import { getVehiclePlate } from "../helpers";
import { VehicleWizardSceneProps } from "../types";

/** Nova ljetna guma ima oko 8 mm profila — prema tome se puni mjerač. */
const NEW_TIRE_PROFILE_MM = 8;

/** Korak "Gume": guma s dimenzijama, dubina profila i podsjetnik za zamjenu. */
const TiresScene: React.FC<VehicleWizardSceneProps> = ({ vehicleInfo }) => {
  const profile = vehicleInfo.profileDepth ?? VEHICLE_WIZARD_SAMPLE.profileDepth;
  const profilePercent = Math.min(100, Math.round((profile / NEW_TIRE_PROFILE_MM) * 100));
  const tireCount = vehicleInfo.tireCount ?? 4;

  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="flex items-center justify-center h-[12.6rem] p-[10px] rounded-t-lg bg-gradient-to-br from-slate-100 to-slate-200">
          <img src="/media/images/vehicles/tires.webp" alt="" className="w-full h-full object-contain mix-blend-multiply" />
        </div>
        <div className="p-5">
          <div className="flex items-center justify-between">
            <div className="text-sm font-bold text-slate-800">
              {vehicleInfo.tireDimensions || VEHICLE_WIZARD_SAMPLE.tireDimensions}
            </div>
            <span className="px-2 py-0.5 rounded-full bg-amber-50 text-[0.65rem] font-semibold text-amber-600">
              {vehicleInfo.tireType || VEHICLE_WIZARD_SAMPLE.tireType}
            </span>
          </div>
          <div className="mt-1 text-[0.7rem] text-slate-400">
            {vehicleInfo.tireManufacturer || VEHICLE_WIZARD_SAMPLE.tireManufacturer} · {tireCount} kom
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="flex items-center justify-between">
            <span className="text-xs font-bold text-slate-800">Dubina profila</span>
            <span className="text-[0.65rem] text-slate-400">DOT {vehicleInfo.dot ?? 2324}</span>
          </div>
          <div className="mt-1 text-lg font-bold text-slate-800">{profile.toLocaleString("hr-HR")} mm</div>
          <div className="mt-3 h-2 rounded-full bg-slate-100">
            <div
              className="h-full rounded-full bg-gradient-to-r from-amber-400 to-emerald-400"
              style={{ width: `${profilePercent}%` }}
            />
          </div>
          <div className="mt-1 flex justify-between text-[0.6rem] text-slate-400">
            <span>1,6 mm</span>
            <span>{NEW_TIRE_PROFILE_MM} mm</span>
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Zamjena guma"
          subtitle={`${getVehiclePlate(vehicleInfo)} · na vrijeme`}
          iconClassName="bg-amber-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#D97706" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M18 8a6 6 0 00-12 0c0 7-3 9-3 9h18s-3-2-3-9M13.7 21a2 2 0 01-3.4 0" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(TiresScene);
